module.exports = __webpack_public_path__ + "static/media/13․06.1621a3fc.webp";